<template>
    <main id="main-container">
        <div class="content">
            <div class="block block-rounded block-bordered">
                <div class="block-header block-header-default">
                    <h3 class="block-title">Thông tin tổng quan</h3>
                    <button type="button" @click.prevent="loadNew" class="btn btn-outline-info" data-toggle="block-option" data-action="state_toggle"
                            data-action-mode="demo">
                        <i class="si si-refresh"></i>Cập nhật
                    </button>
                </div>
                <div class="block-content">
                    <div class="row">
                        <div class="col-md-6 col-xl-6">
                            <router-link class="nav-main-link bg-body-dark" :to="'/categories'">
                                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                                    <div>
                                        <i class="fa fa-2x fa-arrow-alt-circle-up "></i>
                                    </div>
                                    <div class="ml-3 text-right">
                                        <p class="text-xwork-darker font-size-h3 font-w500 mb-0">
                                            {{statisticals.count_categories}}
                                        </p>
                                        <p class="text-xwork-dark mb-0">
                                            Danh mục Games
                                        </p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-md-6 col-xl-6">
                            <router-link class="nav-main-link bg-body-dark" :to="'/games'">
                                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                                    <div>
                                        <i class="fa fa-2x fa-arrow-alt-circle-up text-warning"></i>
                                    </div>
                                    <div class="ml-3 text-right">
                                        <p class="text-xwork-darker font-size-h3 font-w500 mb-0">
                                            {{statisticals.count_games}}
                                        </p>
                                        <p class="text-xwork-dark mb-0">
                                           Games
                                        </p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-xl-6">
                            <router-link class="nav-main-link bg-body-dark" :to="'/contacts'">
                                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                                    <div>
                                        <i class="fa fa-2x fa-arrow-alt-circle-up text-warning"></i>
                                    </div>
                                    <div class="ml-3 text-right">
                                        <p class="text-xwork-darker font-size-h3 font-w500 mb-0">
                                            {{statisticals.count_contacts}}
                                        </p>
                                        <p class="text-xwork-dark mb-0">
                                           Liên hệ
                                        </p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                         <div class="col-md-6 col-xl-6">
                            <router-link class="nav-main-link bg-body-dark" :to="'/users'">
                                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                                    <div>
                                        <i class="far fa-2x fa-user text-danger"></i>
                                    </div>
                                    <div class="ml-3 text-right">
                                        <p class="text-xwork-darker font-size-h3 font-w500 mb-0">
                                            {{statisticals.count_users}}
                                        </p>
                                        <p class="text-xwork-dark mb-0">
                                            Người dùng
                                        </p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import {getApi} from '@/api/statisticals'

    import { mapState } from 'vuex';

    export default {
        name: 'Statisticals',
        data() {
            return {
                listLoading: true,
                statisticals: {}
            }
        },
        computed: {
        //   ...mapState(['locale']),
          headersubscribers: function() {
              return [
                {
                  sortable: false,
                  text: 'Tên',
                  value: 'name'
                },
                {
                  sortable: false,
                  text: 'Email',
                  value: 'email'
                }
              ]

          },
          headercontacts: function() {
              return [
                {
                  sortable: false,
                  text: 'Email',
                  value: 'email'
                },
                {
                  sortable: false,
                  text: 'Tên',
                  value: 'full_name'
                },
                {
                  sortable: false,
                  text: 'Điện thoại',
                  value: 'phone'
                }
              ]

          }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.listLoading = true;
                getApi().then(response => {
                    this.statisticals = response
                })
            },
            loadNew(){
                this.listLoading = true;
                getApi().then(response => {
                    this.statisticals = response
                })
            }
        }
    }
</script>

<style scoped>
    a.nav-main-link.bg-body-dark {
        margin-bottom: 25px;
    }
</style>
